import {
    Component,
    OnInit,
    ViewChild,
    ViewContainerRef,
    OnDestroy,
} from "@angular/core";
import { BaseComponent } from "../Library/BaseComponent";
import { MasterDataService } from "../Services/MasterDataService";
import { ActivatedRoute, Router } from "@angular/router";
import { PMSSignalRService } from "../Services/PMSSignalRService";
import { ComplainSignalRService } from "../Services/ComplainSignalRService";
import { MessagingService } from "../Services/MessagingService";
import { PMSService } from "../Services/PMSService";
import { UserService } from "../Services/UserService";
import { TranslateService } from "@ngx-translate/core";
import { ToastrService } from "ngx-toastr";
import * as moment from "moment";
import { ModalDialogService, SimpleModalComponent } from "ngx-modal-dialog";
import { OpenJobsInformation } from "../Components/OpenJobsInformation/OpenJobsInformation";
import { AppSettings } from "../Library/AppSettings";
import {AuthActionCodes, ModuleLicenceCodes} from "../Models/EnumModels";
import { ShiftSetUpService } from "../Services/ShiftSetUpService";
import { LoginLogoutRequest } from "../Models/RequestModels";
import { ExpiredLicence, PropertyBasicInfo } from "../Models/GlobalEntities";
import { UserProfile } from "../Components/UserProfile/UserProfile";
import { untilDestroyed } from "ngx-take-until-destroy";
import { Configuration } from "../Components/Configuration/Configuration";
import { APIServiceConnector } from "../Services/APIServiceConnector";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import * as _ from "lodash";
import {UFBootstrapService} from "../Services/UFBootstrapService";
import {CookieService} from "ngx-cookie-service";
import { AnalyticsService } from "../Services/AnalyticsService";

@Component({
    selector: "app-nav-menu",
    templateUrl: "./nav-menu.component.html",
})
export class NavMenuComponent
    extends BaseComponent
    implements OnInit, OnDestroy
{
    @ViewChild("openJobsInformation") OpenJobsInformation: OpenJobsInformation;
    @ViewChild("userProfile") userProfile: UserProfile;
    @ViewChild("configuration") configuration: Configuration;
    @ViewChild("licenceContent") licenceContent;
    _AuthActionCodes = AuthActionCodes;
    _ModuleLicenseCodes = ModuleLicenceCodes;
    PropertyDateTime: string;
    AdvancedReportUrl: string;
    OldHTMLUrl: string;
    HKUrl: string;
    InspectionUrl: string;
    KMTUrl: string;
    LoginLogoutRequestLst: Array<LoginLogoutRequest>;
    guid: any;
    isReportAllowerd: boolean;
    LicenceData: Array<ExpiredLicence>;
    licencedProperty: Array<number> = [];
    DateFormat: string;
    hsSysConfigRights: boolean;
    RedirectOldHTML: string;
    RedirectAdvanceReportHTML: string;
    RedirectConfigSilverLight: string;
    RedirectConfigHTML: string;
    ActivePropertyInfo: PropertyBasicInfo;
    AppSettings = AppSettings;
    isLoginViaTool: boolean = false;
    showConfigviaGDPR = false;
    analyticsGlitchURL: any;
    analyticsHKURL: any;
    analyticsServiceURL: any;
    selectedProperty: string = '';
    constructor(
        public translate: TranslateService,
        public toastr: ToastrService,
        public route: ActivatedRoute,
        public router: Router,
        public masterService: MasterDataService,
        public pmsSignalRService: PMSSignalRService,
        public complainSignalRService: ComplainSignalRService,
        public pmsService: PMSService,
        private modalDialogService: ModalDialogService,
        private viewContainer: ViewContainerRef,
        public messagingService: MessagingService,
        public userService: UserService,
        public shiftSetUpService: ShiftSetUpService,
        public apiService: APIServiceConnector,
        private modalService: NgbModal,
        private ufBootstrapService: UFBootstrapService,
        public analyticsService: AnalyticsService
    ) {
        super(translate, toastr, route, router, masterService);
    }

    customSearchFn(term: string, item: any) {
      term = term.toLocaleLowerCase();
      return item.PropertyName.toLocaleLowerCase().indexOf(term) > -1;
     }

     didChangeResponseType(event: any){
        if(event && event.PropertyId){
            if(this.masterService.ActivePropertyID != event.PropertyId){
                this.ChangeProperty(event.PropertyId);
                this.selectedProperty = event.PropertyName
            }
        }

     }

    ngOnDestroy(): void {}

    ngOnInit(): void {
        this.isLoginViaTool =
            this.apiService.getCookie("LoginViaTool") == "true";
        if (this.isLoginViaTool) {
            if (
                this.masterService.LoggedInUserData.IsPropertyAdmin &&
                this.masterService.LoggedInUserData.DepartmentId == null &&
                this.masterService.LoggedInUserData.DesignationId == null
            ) {
                this.showConfigviaGDPR = true;
            }
        }
        this.GetCurrentPropDateTime();
        setInterval(() => {
            this.GetCurrentPropDateTime();
        }, 1000);
        this.DateFormat = this.masterService.GetPropertyDateFormat(null);

        this.AdvancedReportUrl = AppSettings.URL_AdvancedReports;
        this.OldHTMLUrl = AppSettings.URL_OldHTML;

        this.userService.StaffImageUpdated.pipe(untilDestroyed(this)).subscribe(
            (value) => {
                this.guid = this.generateGuid();
            }
        );

        this.isReportAllowerd =
            this.masterService.LoggedInUserData.PropertyAuthorizations.filter(
                (a) =>
                    a.PropertyId == this.masterService.ActivePropertyID &&
                    a.ModuleCode == "RPT" &&
                    a.IsAllowed == true
            ).length > 0 || this.masterService.LoggedInUserData.IsPropertyAdmin;

        this.LicenceDetails();

        this.ActivePropertyInfo = this.masterService.GetProperty(
            this.masterService.ActivePropertyID
        );
        this.selectedProperty = this.ActivePropertyInfo.PropertyName;
        //let PropertyCode = this.getCookie('_propertyCode');
        //if (PropertyCode) {
        //    let PropertyID = this.masterService.LoggedInUserData.Properties.filter(x => x.PropertyCode.toLocaleUpperCase() == PropertyCode.toUpperCase())[0].PropertyId
        //    if (PropertyID) {
        //        this.ChangeProperty(PropertyID);
        //    }
        //}

        this.hsSysConfigRights =
            this.masterService.LoggedInUserData.PropertyAuthorizations
                .filter((x) => x.ModuleCode == "SYSCON" && x.ActionCode == 'SYS_VW' && x.IsAllowed == true)
                .length > 0;

        this.ChangeURL();
        this.checkServiceAnalytics(()=>{
            this.checkGlitchAnalytics(() => {
                this.checkHKAnalytics()
            });
        });
    }
    async checkGlitchAnalytics(callback = null) {
        if (this.CheckAuth_Action(this._AuthActionCodes.CreateKnowGlitchReports)) {
          this.analyticsGlitchURL = await this.analyticsService.fetchAnalyticsURL('glitch');
        }
        if (callback) {
            callback();
        }
    }
    async checkHKAnalytics() {
        if (this.CheckAuth_Action(this._AuthActionCodes.EditHKReports)) {
            this.analyticsHKURL = await this.analyticsService.fetchAnalyticsURL('hk');
        }
    }
    async checkServiceAnalytics(callback=null) {
        if (this.CheckAuth_Action(this._AuthActionCodes.CreateAdvancedKnowServiceReports)) {
          this.analyticsServiceURL= await this.analyticsService.fetchAnalyticsURL('service');
        }
        if (callback) {
            callback();
        }
    }

    GetCurrentPropDateTime(): void {
        let timeZones =
            this.masterService.GetProperty(this.masterService.ActivePropertyID)
                .BaseUtcOffset /
            60 /
            60;

        let date = new Date();
        let tzDifference = timeZones * 60 + date.getTimezoneOffset();
        let offset = tzDifference * 60 * 1000;

        this.PropertyDateTime = moment(new Date().getTime() + offset).format(
            "dddd, MMMM DD, YYYY HH:mm"
        );
    }
    Toggle(ModuleID): void {
        if (ModuleID == null) {
            this.masterService.CurrentUIState.LeftExpanded = false;
            return;
        }
        if (ModuleID == 1 || ModuleID == 2) {
            if (!this.CheckModuleLicence(ModuleID)) return;
        }
        let cMod = this.masterService.CurrentUIState.SelectedModule;

        if (cMod == ModuleID) {
            this.masterService.CurrentUIState.LeftExpanded =
                !this.masterService.CurrentUIState.LeftExpanded;
        } else {
            this.masterService.CurrentUIState.SelectedModule = ModuleID;
            this.masterService.CurrentUIState.LeftExpanded = true;
        }
    }
    CheckModuleLicence(ModuleID): boolean {
        if (
            ModuleID == 1 &&
            this.masterService.GetProperties_ModuleLicence("TTN_RRESP")
                .length == 0
        ) {
            alert("Licence of KNOW Service not available.");
            return false;
        } else if (
            ModuleID == 2 &&
            this.masterService.GetProperties_ModuleLicence("TTN_GLIT").length ==
                0
        ) {
            alert("Licence of KNOW Glitch not available.");
            return false;
        } else if (
            ModuleID == 11 &&
            !this.masterService.CheckActiveLicence_Module(
                this.masterService.ActivePropertyID,
                "TTN_HK"
            )
        ) {
            alert("Licence of KNOW Housekeeping not available.");
            return false;
        } else if (
            ModuleID == 5 &&
            !this.masterService.CheckActiveLicence_Module(
                this.masterService.ActivePropertyID,
                "TTN_CHKL"
            )
        ) {
            alert("Licence of KNOW Inspection not available.");
            return false;
        } else if (
            ModuleID == 8 &&
            !this.masterService.CheckActiveLicence_Module(
                this.masterService.ActivePropertyID,
                "KMT_CORE"
            )
        ) {
            alert("Licence of KNOW Maintenance not available.");
            return false;
        }
        return true;
    }

    NavClicked(ScreenName): void {
        this.masterService.CurrentUIState.SreenName = ScreenName;
        this.masterService.CurrentUIState.LeftExpanded = false;
    }

    ChangeLanguage(lang): void {
        this.masterService.ChangeScreenLanguage(lang).then((data) => {
            location.reload();
        });
    }
    ChangeProperty(propertyId): void {
        this.masterService.ActivePropertyID = propertyId;
        this.pmsService.GuestLookup_Get(propertyId);
        this.isReportAllowerd =
            this.masterService.LoggedInUserData.PropertyAuthorizations.filter(
                (a) =>
                    a.PropertyId == this.masterService.ActivePropertyID &&
                    a.ModuleCode == "RPT" &&
                    a.IsAllowed == true
            ).length > 0 || this.masterService.LoggedInUserData.IsPropertyAdmin;
        this.ChangeURL();
    }
    ToggleNotificationCenter(): void {
        this.messagingService.ToggleNotificationCenter();
    }

    LicenceDetails(): void {
        if (
            this.masterService.LoggedInUserData.Licence &&
            this.masterService.LoggedInUserData.Licence.length > 0
        ) {
            this.LicenceData = this.masterService.LoggedInUserData.Licence;
            for (let i = 0; i < this.LicenceData.length; i++) {
                this.licencedProperty.push(this.LicenceData[i].PropertyId);
            }
            this.licencedProperty = _.uniq(this.licencedProperty);
            this.modalService.open(this.licenceContent, {
                size: "lg",
                centered: true,
                backdrop: "static",
            });
        }
    }

    //ToggleNotificationOnHeaderClick(): void {
    //    this._messagingService.ToggleNotificationOnHeaderClick();
    //}

    UserLogout(): void {
        let confirmTitle = this.translate.instant("TITLE.TITLE_PLEASE_CONFIRM");
        let btnYes = this.translate.instant("BTN.BTN_YES");
        let btnNo = this.translate.instant("BTN.BTN_NO");
        let btnCancel = this.translate.instant("BTN.BTN_CANCEL");

        if (this.masterService.LoggedInUserData.IsServiceStaff) {
            let confirmText = this.translate.instant(
                "LBL.CONFIRM_END_SHIFT_WITH_LOGOUT"
            );

            this.modalDialogService.openDialog(this.viewContainer, {
                title: confirmTitle,
                childComponent: SimpleModalComponent,
                data: {
                    text: confirmText,
                },
                actionButtons: [
                    {
                        text: btnYes,
                        buttonClass: "btn btn-primary",
                        onAction: () => {
                            let OpenJobPropertyList: any = [];
                            this.userService.GetOpenCalls().then((data) => {
                                if (data.HasError) {
                                    this.GetMultilingualToast(
                                        data.Errors[0].ErrorMessage,
                                        "error"
                                    );
                                    return true;
                                }
                                for (let i = 0; i < data.Result.length; i++) {
                                    if (data.Result[i].Count > 0)
                                        OpenJobPropertyList.push(
                                            data.Result[i].PropertyId
                                        );
                                }
                                if (OpenJobPropertyList.length > 0)
                                    this.OpenJobsInformation.Open(
                                        OpenJobPropertyList
                                    );
                                else {
                                    this.SendLogoutRequest();
                                }
                            });
                            return true;
                        },
                    },
                    {
                        text: btnNo,
                        buttonClass: "btn btn-secondary",
                        onAction: () => {
                            this.apiService.signOutUser();
                            return true;
                        },
                    },
                    {
                        text: btnCancel,
                        buttonClass: "btn btn-outline-secondary",
                        onAction: () => {
                            return true;
                        },
                    },
                ],
            });
        } else {
            let confirmText =
                this.translate.instant("LBL.LOGOUT_CONFIRM") + " ?";

            this.modalDialogService.openDialog(this.viewContainer, {
                title: confirmTitle,
                childComponent: SimpleModalComponent,
                data: {
                    text: confirmText,
                },
                actionButtons: [
                    {
                        text: btnYes,
                        buttonClass: "btn btn-primary",
                        onAction: () => {
                            this.apiService.signOutUser();
                        },
                    },
                    {
                        text: btnNo,
                        buttonClass: "btn btn-secondary",
                        onAction: () => {
                            return true;
                        },
                    },
                ],
            });
        }
    }

    SetShiftLogRequestObj() {
        let RequestObj: LoginLogoutRequest = new LoginLogoutRequest();
        RequestObj.Properties = [];
        RequestObj.StaffId = this.masterService.LoggedInUserData.StaffId;
        RequestObj.IsLogin = false;
        RequestObj.logoutOptionComplain = [];
        return RequestObj;
    }

    SendLogoutRequest() {
        this.LoginLogoutRequestLst = [];
        const loggedInUser = this.masterService.LoggedInUserData;
        const userProperties = (loggedInUser && loggedInUser.Properties) || [];
        let req = this.SetShiftLogRequestObj();
        req.Properties = userProperties.map((property) => property.PropertyId);
        this.LoginLogoutRequestLst.push(req);
        this.shiftSetUpService
            .LoginLogout(this.LoginLogoutRequestLst)
            .then((data) => {
                if (data.HasError) {
                    this.GetMultilingualToast(
                        data.Errors[0].ErrorMessage,
                        "error"
                    );
                    return true;
                }
                this.apiService.signOutUser();
            });
    }

    generateGuid() {
        return (
            this.s4() +
            this.s4() +
            "-" +
            this.s4() +
            "-" +
            this.s4() +
            "-" +
            this.s4() +
            "-" +
            this.s4() +
            this.s4() +
            this.s4()
        );
    }

    s4() {
        return Math.floor((1 + Math.random()) * 0x10000)
            .toString(16)
            .substring(1);
    }

    onUserProfileOpen(): void {
        this.userProfile.Open();
    }

    RedirectConfig(): void {
        this.masterService
            .ChangeProperty(this.masterService.ActivePropertyID)
            .then((data) => {});

        if (!this.isIE()) {
            this.configuration.Open();
        } else {
            window.open(
                AppSettings.URL_Config.replace(
                    "{token}",
                    this.apiService.getSessionCookie()
                ),
                "_blank"
            );
        }
    }

    isIE(): boolean {
        let ua = navigator.userAgent;
        /* MSIE used to detect old browsers and Trident used to newer ones*/
        var is_ie = ua.indexOf("MSIE ") > -1 || ua.indexOf("Trident/") > -1;

        return is_ie;
    }
    ChangeURL(): void {
        let propertyCode = this.masterService.GetProperty(this.masterService.ActivePropertyID).PropertyCode;

        this.RedirectOldHTML =
            "/Pages/Staff_ChangeProperty?PropertyID=" +
            this.masterService.ActivePropertyID +
            "&RedirectURL=" +
            encodeURI(AppSettings.URL_OldHTML);

        if (!this.RedirectOldHTML.match(/ksv5/g)) {
            this.RedirectOldHTML = "";
        }

        this.RedirectAdvanceReportHTML = AppSettings.ShowAdvanceReportDirectly ?
            AppSettings.URL_AdvancedReports + '#/customer/' + propertyCode :
            "/Pages/Staff_ChangeProperty?PropertyID=" +
            this.masterService.ActivePropertyID +
            "&RedirectURL=" +
            encodeURI(AppSettings.URL_AdvancedReports);

        if (AppSettings.URL_Config) {
            this.RedirectConfigSilverLight =
                "/Pages/Staff_ChangeProperty?PropertyID=" +
                this.masterService.ActivePropertyID +
                "&RedirectURL=" +
                encodeURIComponent(
                    AppSettings.URL_Config.replace(
                        "{token}",
                        this.apiService.getSessionCookie()
                    )
                );
        }

        const zoneUrls = this.masterService.GetZoneUrls(this.masterService.ActivePropertyID);

        if (AppSettings.EnableUnifocusSSO) {
            const hkWebUrl = zoneUrls && zoneUrls.HousekeepingWebUrl ? zoneUrls.HousekeepingWebUrl + '#/customer/'+ propertyCode  : null;
            const insWebUrl = zoneUrls && zoneUrls.InspectionWebUrl ? zoneUrls.InspectionWebUrl + '#/customer/'+ propertyCode : null;
            this.HKUrl = hkWebUrl ? encodeURI(hkWebUrl) : null;
            this.InspectionUrl = insWebUrl ? encodeURI(insWebUrl) : null;
        } else {
            this.HKUrl = AppSettings.URL_HK ? encodeURI(
                AppSettings.URL_HK +
                "&KSV_PROPERTY_CODE=" +
                propertyCode +
                "&KSV_SESSION_TOKEN=" +
                this.apiService.getSessionCookie()
            ) : null;

            this.InspectionUrl = AppSettings.URL_Inspection ? encodeURI(
                AppSettings.URL_Inspection +
                "&KSV_PROPERTY_CODE=" +
                propertyCode +
                "&KSV_SESSION_TOKEN=" +
                this.apiService.getSessionCookie()
            ) : null;
        }

        this.KMTUrl = encodeURI(AppSettings.URL_KMT);
        this.RedirectConfigHTML = encodeURI(AppSettings.URL_PlatformConfigHTML);
    }

}
